import GetRenderView from '../GetRenderView';
import {
  MEDICAL_HEALTH_INFORMATION_BRANCH_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME,
  MEDICAL_HEALTH_INFORMATION_NAME
} from '../constants/constants';
import Layout from './Layout';
import { useNavigate } from 'react-router';
import { useMedicalHealthInformationContext } from '../Context';

const MedicalHealthInformationForm = () => {
  const navigate = useNavigate();
  const { activeStep, setActiveStep } = useMedicalHealthInformationContext();

  const handleBackClick = () => {
    if (activeStep === MEDICAL_HEALTH_INFORMATION_NAME) {
      navigate('/patient/top');
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_NAME) {
      setActiveStep(MEDICAL_HEALTH_INFORMATION_NAME);
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME) {
      setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_NAME);
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_DETAIL_NAME) {
      setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME);
    } else {
      navigate('/patient/top');
    }
  };

  return (
    <>
      <Layout title="医療健康情報一覧" handleBack={handleBackClick}>
        {GetRenderView(activeStep)}
      </Layout>
    </>
  );
};
export default MedicalHealthInformationForm;
